module.exports = __webpack_public_path__ + "images/hero_mission3_38d4a783dcb5cb68fa98c6d36072d878.png";